import { render, staticRenderFns } from "./addOrEditNews.vue?vue&type=template&id=3f586fdb&scoped=true"
import script from "./addOrEditNews.vue?vue&type=script&lang=js"
export * from "./addOrEditNews.vue?vue&type=script&lang=js"
import style0 from "./addOrEditNews.vue?vue&type=style&index=0&id=3f586fdb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f586fdb",
  null
  
)

export default component.exports